import { render } from "./Beauty.vue?vue&type=template&id=2eaaecc5"
import script from "./Beauty.vue?vue&type=script&lang=js"
export * from "./Beauty.vue?vue&type=script&lang=js"

import "./Beauty.vue?vue&type=style&index=0&id=2eaaecc5&lang=less"

import exportComponent from "/Users/longliu/Desktop/projects/povertyalleviation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__